var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReReColourRe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248.59 142.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.3415,
    y1: 35.2138,
    x2: -7.7464,
    y2: 119.3003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.17,88.27l37.01,49.03H81.65L48.34,89.75H34.09v47.55H4.86V5h59.58c33.31,0,46.07,20.91,46.07,42.37 c0,17.95-9.44,36.08-31.46,40.89H80.17z M34.09,27.58v39.78h22.57c13.88,0,25.35-3.15,25.35-19.98c0-17.21-11.47-19.8-25.35-19.8 H34.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050644915177830384850000003031031365344935598_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.2593,
    y1: 33.5345,
    x2: -12.6216,
    y2: 124.4781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050644915177830384850000003031031365344935598_)"
    },
    d: "M127.21,142.3H79.05L45.74,94.75h-6.64 v47.55H-0.14V0h64.58c16.68,0,30.23,5.09,39.19,14.73c7.66,8.24,11.88,19.83,11.88,32.64c0,16.34-7.34,35.28-27.27,43.3 L127.21,142.3z M39.09,62.36h17.57c15.02,0,20.35-3.92,20.35-14.98c0-11.2-4.94-14.8-20.35-14.8H39.09V62.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020374064112179441970000013408764879508407222_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.515,
    y1: 28.2493,
    x2: 126.757,
    y2: 117.0061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020374064112179441970000013408764879508407222_)"
    },
    d: "M169.05,112.91h74.46v24.39H140.97V5 h96.27v24.39h-68.18v29.75h60.24v25.68h-60.24V112.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149371067510902236120000008366399323314496440_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.2189,
    y1: 24.2553,
    x2: 121.0526,
    y2: 121.0004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA4090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C67AC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149371067510902236120000008366399323314496440_)"
    },
    d: "M248.52,142.3H135.97V0h106.27v34.39 h-68.18v19.75h60.24v35.68h-60.24v18.09h74.46V142.3z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReReColourRe);
export default __webpack_public_path__ + "static/media/re_RE-colour_RE.0128de9be962e26fa54d60fb4e2555ea.svg";
export { ForwardRef as ReactComponent };